import Isotope from "isotope-layout";
import { t } from "../../utils/translations";

const updateCounter = (items) => {
  const counterPlaceholder = document.querySelector(".counter");
  const buttonCounter = document.querySelector(".button-counter");

  if (items.length === 1) {
    counterPlaceholder.innerHTML = `<span>${items.length}</span> <span>${t(
      "search_found_result"
    )}</span>`;
    buttonCounter.innerText = `${t("search_show")} ${items.length} ${t(
      "search_found_result"
    )}`;
  } else {
    counterPlaceholder.innerHTML = `<span>${items.length}</span> <span>${t(
      "search_found_results"
    )}</span>`;
    buttonCounter.innerText = `${t("search_show")} ${items.length} ${t(
      "search_found_result"
    )}`;
  }
};

const handleFilters = (activeFilters, iso) => {
  // combine active filters
  const filterValue = activeFilters.length ? activeFilters.join("") : "*";

  iso.arrange({ filter: filterValue });
  updateCounter(iso.getFilteredItemElements());
};

const init = () => {
  const filters = document.querySelectorAll(".filter-group input");
  const resetFilters = document.querySelector(".reset-filters");
  const toggleFilters = document.querySelectorAll(
    "[data-action=toggle-filters]"
  );
  const root = document.documentElement;
  const resultContainer = document.querySelector(".result-container");
  const panelWrapper = document.querySelector(".panel-wrapper");
  const iso = new Isotope(resultContainer, {
    itemSelector: ".result",
    layoutMode: "fitRows",
    percentPosition: true,
  });

  if (filters.length > 0) {
    let activeFilters = [];

    filters.forEach((filter) => {
      filter.addEventListener("change", (event) => {
        if (event.currentTarget.checked) {
          activeFilters.push(filter.value);
          handleFilters(activeFilters, iso);
        } else {
          activeFilters = activeFilters.filter((item) => item !== filter.value);
          handleFilters(activeFilters, iso);
        }
      });
    });

    resetFilters.addEventListener("click", (e) => {
      e.preventDefault();
      activeFilters = []; // empty active filters.
      filters.forEach((filter) => {
        filter.checked = false; // reset all checkboxes to unchecked.
      });
      handleFilters(activeFilters, iso);
    });
  }

  toggleFilters.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      if (root.classList.contains("has-filters-open")) {
        root.classList.remove("has-filters-open");
      } else {
        root.classList.add("has-filters-open");
      }
    });
  });
};

export default init;
